// Simplified variant naming for experiments only (both Statsig and Ninetailed).
// The legacy Ninetailed version (components/shared/Ninetailed/getVariantDisplayName.ts)
// also handles personalizations via ExperienceType — not needed here since
// SelectedPersonalization only carries experiment data.
export function getVariantDisplayName(variantIndex: number): string {
  if (variantIndex === 0) return 'Control';
  return `Variant ${variantIndex}`;
}
